import React from 'react';
import { Row } from 'antd';
import { Image, MenuContainer, MenuItem, MenuText } from '../../../../shared.style';
import BoxIcon from '../../../../assets/icons/box.png';

const MenuAccountProduct = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem onClick={() => history.push(`/account/products`)}>
          <Image src={BoxIcon} alt="products" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>วัสดุที่รับ</MenuText>
      </Row>
    </MenuContainer>
  );
};

export default MenuAccountProduct;



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuAccountProduct/index.js